import React from 'react';
import get from 'lodash/get';
import LegacyTextRenderer from './LegacyTextRenderer';
import ExcerptRenderer from './ExcerptRenderer';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import DeviationMediaService from '../utils/DeviationMediaService';
import MonoView from '../DaEditorNg/MonoView';
import GalleryView from '../DaEditorNg/GalleryView';
import EmoteSelectorNg from '../EmoteSelectorNg';
import { useSafeUrlHandler } from '../SafeUrlModal/hooks/useSafeUrlHandler';
import InlineView from '../DaEditorNg/InlineView';
import s from './LegacyTextRenderer.scss';
export const externalRenderers = {
    deviation: MonoView,
    gallery: GalleryView,
    mediaService: DeviationMediaService,
    emoteSelector: EmoteSelectorNg,
    inline: InlineView
};
const TextRenderer = /*#__PURE__*/ React.forwardRef(({ textContent, className, fallbackToExcerpt = true, htmlExcerptLegacy, isPollWithHtmlExcerpt, legacyTheme, excerptOnly, viewerKey, disableStylesForLegacy, emptyPlaceHolder = '', withSafetyCheckModal, tipTapViewer, tipTapPresetId, cookieType, defaultSize }, ref)=>{
    const safeHandler = useSafeUrlHandler();
    if (!textContent) {
        return null;
    }
    const type = get(textContent, 'html.type');
    const markup = get(textContent, 'html.markup');
    if (!markup || excerptOnly) {
        if (!fallbackToExcerpt) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "TextRendererExcerpt"
        }, /*#__PURE__*/ React.createElement(ExcerptRenderer, {
            textContent: textContent,
            className: className,
            emptyPlaceHolder: emptyPlaceHolder,
            legacyTheme: legacyTheme,
            htmlExcerptLegacy: htmlExcerptLegacy,
            isPollWithHtmlExcerpt: isPollWithHtmlExcerpt,
            disableStylesForLegacy: disableStylesForLegacy,
            ref: ref
        }));
    }
    switch(type){
        case 'writer':
            return /*#__PURE__*/ React.createElement(ErrorBoundary, {
                debugComponent: "TextRendererWriter"
            }, /*#__PURE__*/ React.createElement("div", {
                ref: ref,
                className: s['legacy-container']
            }, /*#__PURE__*/ React.createElement(LegacyTextRenderer, {
                className: className,
                html: markup,
                theme: legacyTheme,
                disableStyles: disableStylesForLegacy,
                withSafetyCheckModal: withSafetyCheckModal
            })));
        case 'tiptap':
            const ViewerTipTap = tipTapViewer;
            if (!tipTapViewer) {
                return null;
            }
            try {
                if (withSafetyCheckModal) {
                    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
                        debugComponent: "TextRendererTipTap"
                    }, /*#__PURE__*/ React.createElement("div", {
                        onClickCapture: safeHandler
                    }, /*#__PURE__*/ React.createElement(ViewerTipTap, {
                        key: viewerKey,
                        contentJson: JSON.parse(markup),
                        className: className,
                        externalRenderers: externalRenderers,
                        cookieType: cookieType,
                        defaultSize: defaultSize,
                        ref: ref,
                        presetId: tipTapPresetId
                    })));
                }
                return /*#__PURE__*/ React.createElement(ErrorBoundary, {
                    debugComponent: "TextRendererTipTap"
                }, /*#__PURE__*/ React.createElement(ViewerTipTap, {
                    contentJson: JSON.parse(markup),
                    className: className,
                    externalRenderers: externalRenderers,
                    cookieType: cookieType,
                    defaultSize: defaultSize,
                    ref: ref,
                    presetId: tipTapPresetId
                }));
            } catch (e) {
                return null;
            }
        default:
            return null;
    }
});
TextRenderer.displayName = 'TextRenderer';
export default TextRenderer;

//# sourceMappingURL=TextRenderer.js.map